/**
 * Mouth Material Control Script
 * Provides easy-to-use global functions for controlling mouth material properties
 * These functions are made available in the browser console for easy scripting
 */

// Quick preset functions for common mouth material configurations
window.makeMouthRealistic = function() {
    if (window.mouthMaterialManager) {
        window.mouthMaterialManager.applyPreset('realistic');
        console.log('✅ Applied realistic mouth material settings');
        return window.mouthMaterialManager.getStatus();
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return null;
    }
};

window.makeMouthGlossy = function() {
    if (window.mouthMaterialManager) {
        window.mouthMaterialManager.applyPreset('glossy');
        console.log('✅ Applied glossy mouth material settings');
        return window.mouthMaterialManager.getStatus();
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return null;
    }
};

window.makeMouthMatte = function() {
    if (window.mouthMaterialManager) {
        window.mouthMaterialManager.applyPreset('matte');
        console.log('✅ Applied matte mouth material settings');
        return window.mouthMaterialManager.getStatus();
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return null;
    }
};

window.makeMouthWet = function() {
    if (window.mouthMaterialManager) {
        window.mouthMaterialManager.applyPreset('wet');
        console.log('✅ Applied wet mouth material settings');
        return window.mouthMaterialManager.getStatus();
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return null;
    }
};

// Default preset functions
window.applyMouthDefault = function() {
    if (window.mouthMaterialManager) {
        window.mouthMaterialManager.applyPreset('default');
        console.log('✅ Applied default mouth material settings');
        return window.mouthMaterialManager.getStatus();
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return null;
    }
};

window.applyTeethDefault = function() {
    if (window.teethMaterialManager) {
        window.teethMaterialManager.applyPreset('default');
        console.log('✅ Applied default teeth material settings');
        return window.teethMaterialManager.getStatus();
    } else {
        console.warn('❌ Teeth material manager not available - load a 3D model first');
        return null;
    }
};

// Apply default settings to both teeth and mouth
window.applyAllDefaultMaterials = function() {
    let teethResult = false;
    let mouthResult = false;
    
    if (window.teethMaterialManager) {
        window.teethMaterialManager.applyPreset('default');
        teethResult = true;
    }
    
    if (window.mouthMaterialManager) {
        window.mouthMaterialManager.applyPreset('default');
        mouthResult = true;
    }
    
    if (teethResult && mouthResult) {
        console.log('✅ Applied default material settings to both teeth and mouth');
    } else if (teethResult) {
        console.log('✅ Applied default teeth material settings');
        console.warn('❌ Mouth material manager not available');
    } else if (mouthResult) {
        console.log('✅ Applied default mouth material settings');
        console.warn('❌ Teeth material manager not available');
    } else {
        console.warn('❌ Neither teeth nor mouth material managers are available - load a 3D model first');
    }
    
    return { teeth: teethResult, mouth: mouthResult };
};

// Advanced control functions
window.setMouthEnvMapIntensity = function(intensity) {
    if (window.mouthMaterialManager) {
        const success = window.mouthMaterialManager.setEnvMapIntensity(intensity);
        if (success) {
            console.log(`✅ Set mouth environment map intensity to: ${intensity}`);
        }
        return success;
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return false;
    }
};

window.setMouthClearcoat = function(clearcoat, roughness = 0.1) {
    if (window.mouthMaterialManager) {
        const success = window.mouthMaterialManager.setClearcoat(clearcoat, roughness);
        if (success) {
            console.log(`✅ Set mouth clearcoat: ${clearcoat}, roughness: ${roughness}`);
        }
        return success;
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return false;
    }
};

window.resetMouthMaterial = function() {
    if (window.mouthMaterialManager) {
        const success = window.mouthMaterialManager.resetMaterials();
        if (success) {
            console.log('✅ Reset mouth materials to original state');
        }
        return success;
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return false;
    }
};

// Utility function to show current mouth material status
window.getMouthMaterialStatus = function() {
    if (window.mouthMaterialManager) {
        const status = window.mouthMaterialManager.getStatus();
        console.log('📊 Mouth Material Status:', status);
        return status;
    } else {
        console.warn('❌ Mouth material manager not available - load a 3D model first');
        return null;
    }
};

// Display available mouth material commands
window.showMouthMaterialCommands = function() {
    console.log(`
🦷 MOUTH MATERIAL CONTROL COMMANDS
====================================

Basic Functions:
• setMouthMetallicness(value)     - Control metallic appearance (0.0-1.0)
• setMouthRoughness(value)        - Control surface roughness (0.0-1.0)  
• setMouthColor(color)            - Set mouth color (hex: 0xff5555)
• applyMouthPreset(preset)        - Apply preset ('realistic', 'glossy', 'matte', 'wet')

Quick Presets:
• applyMouthDefault()            - Apply default mouth material settings
• applyTeethDefault()            - Apply default teeth material settings  
• applyAllDefaultMaterials()     - Apply defaults to both teeth and mouth
• makeMouthRealistic()           - Natural looking mouth (non-metallic)
• makeMouthGlossy()              - Shiny, reflective mouth
• makeMouthMatte()               - Completely non-reflective mouth
• makeMouthWet()                 - Wet, glossy appearance with clearcoat

Advanced Controls:
• setMouthEnvMapIntensity(value)  - Control environment reflections (0.0-2.0)
• setMouthClearcoat(coat, rough)  - Add glossy coating effect
• resetMouthMaterial()           - Restore original materials

Status & Info:
• getMouthMaterialStatus()       - Show current configuration
• showMouthMaterialCommands()    - Display this help

Example Usage:
setMouthMetallicness(0.0);       // Make mouth completely non-metallic
makeMouthRealistic();            // Apply natural mouth settings
setMouthColor(0xcc5555);         // Set natural mouth color
`);
};

// Auto-display commands when script loads
console.log('🦷 Mouth Material Controls loaded! Type showMouthMaterialCommands() for help');